import { useMemo, useState, type ReactNode } from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClientProvider } from '@tanstack/react-query';

import { ToastProvider } from '@/components/common/ToastProvider';
import { createQueryClient } from '@/lib/query-client';
import { useResolvedColorMode } from '@/store/color-mode';
import { createAppTheme } from '@/theme';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  // One client per app instance; creating it in state keeps StrictMode's double
  // render from throwing away the cache.
  const [queryClient] = useState(createQueryClient);

  const mode = useResolvedColorMode();
  const theme = useMemo(() => createAppTheme(mode), [mode]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline enableColorScheme />
        <ToastProvider>{children}</ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
